import React, {
  Fragment,
  useContext,
  useEffect,
  useState,
  useRef,
} from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Autocomplete from "@mui/material/Autocomplete";
import { AlertContext } from "../../../context/AlertContext";
import { ServiciosContext } from "../../../context/ServiciosContext";
import { ConfiguracionContext } from "../../../context/ConfiguracionContext";
import { ThemeProvider, createMuiTheme } from "@mui/material/styles";
import { makeStyles } from "@mui/material/styles";
import Fab from "@mui/material/Fab";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import Spinner from "./../Spinner";
import { AuthContext } from "../../../context/AuthContext";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "../../../assets/css/DataTableDemo.css";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { Tag } from "primereact/tag";
import { InputText } from "primereact/inputtext";
import ButtonMui from "@mui/material/Button";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { Navigate, useNavigate } from "react-router-dom";
import { saveAs } from "file-saver";
import Menu from "./../Menu";
import { InputNumber } from "primereact/inputnumber";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { InputMask } from "primereact/inputmask";
import IconButton from "@mui/material/IconButton";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";

const exportColumnsListado = [
  { title: "Nº Afiliado.", dataKey: "id_titular" },
  { title: "Nombre/Razón Social", dataKey: "nombre_razonsocial" },
  { title: "Domicilio", dataKey: "domicilio" },
  { title: "Localidad", dataKey: "localidad" },
  { title: "Grupo", dataKey: "grupo" },
  { title: "Plan", dataKey: "plan" },
  { title: "Empresa", dataKey: "empresa" },
  { title: "Vigencia", dataKey: "vigencia" },
  { title: "Cuota", dataKey: "cuota" },
  { title: "Susp. Desde", dataKey: "fsuspendidodesde" },
  { title: "Susp. Hasta", dataKey: "fsuspendidohasta" },
  { title: "Motivo", dataKey: "msuspendido" },
];

const exportColumnsListado2030 = [
  { title: "Nº Afiliado.", dataKey: "id_titular" },
  { title: "Nombre/Razón Social", dataKey: "nombre_razonsocial" },
  { title: "Cuotas", dataKey: "cuotas" },
];


export default function ListadosSuspendidos(props) {
  const [globalFilter, setGlobalFilter] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);

  const [visibleFechas, setVisibleFechas] = useState(true);
  const [grupo, setGrupo] = useState(null);
  const [incluyeIntegrantes, setIncluyeIntegrantes] = useState(false);
  const [todasLasEmpresas, setTodasLasEmpresas] = useState(false);
  const [a2030, setA2030] = useState(false);
  const [fechaDesde, guardarFechaDesde] = useState(null);
  const [fechaHasta, guardarFechaHasta] = useState(null);
  const toast = useRef(null);

  let navigate = useNavigate();

  //Context

  const alertContext = useContext(AlertContext);
  const { mensajeAlerta } = alertContext;

  const authContext = useContext(AuthContext);
  const { state, usuarioAutenticado } = authContext;

  const configuracionContext = useContext(ConfiguracionContext);
  const {
    statusAcceso,
    configuracion,
    empresaElegida,
    listadoExcel,
    obtenerAcceso,
    obtenerSuspendidos,
  } = configuracionContext;

  useEffect(() => {
    if (state.usuario) {
      obtenerAcceso({
        usuarioId: state.usuario.id,
        layout: "ListadosSuspendidos",
      });
    }
  }, [state.id]);

  function formatDate(input) {
    var datePart = input.match(/\d+/g),
      year = datePart[0],
      month = datePart[1],
      day = datePart[2];
    return day + "/" + month + "/" + year;
  }

  const startClick = (e) => {
    setTimeout(() => {
      navigate(`/listadossuspendidos`);
      setVisibleFechas(true);
    }, 2000);
  };

  const exitClick = (e) => {
    navigate("/");
  };

  const onHideFechas = (e) => {
    setVisibleFechas(false);
  };

  const aceptarFechas = async (exportType) => {
    //e.preventDefault();
    //Validar

    var elem;
    let fdesde = null;
    let fhasta = null;

    if (!a2030) {
      if (fechaDesde === null) {
        mensajeAlerta(
          "Listados de Bajas",
          "Debe indicar fecha desde !.",
          "error",
        );
        return;
      }

      if (fechaHasta === null) {
        mensajeAlerta(
          "Listados de Bajas",
          "Debe indicar fecha hasta !.",
          "error",
        );
        return;
      }

      if (fechaDesde > fechaHasta) {
        mensajeAlerta(
          "Listados de Bajas",
          "Fecha desde no puede ser mayor que fecha hasta !.",
          "error",
        );
        return;
      }

      fdesde = fechaDesde + "T00:00:00";
      fhasta = fechaHasta + "T23:59:59";
    }

    toast.current.show({
      severity: "info",
      summary: "Listados",
      detail: "Obteniendo información... !",
      life: 3000,
    });

    await obtenerSuspendidos({
      desde: fdesde,
      hasta: fhasta,
      todasLasEmpresas,
      a2030,
      empresaElegida,
      exportType,
    }).then((data) => {
      if (exportType === "excel") {
        elem = document.getElementById("expButtonExcel");
        elem.click();
      }
      if (exportType === "pdf") {
        elem = document.getElementById("expButtonPdf");
        elem.click();
      }
    });
    /*
    onHideFechas();
    setGrupo(null);
    guardarVigencia({
      desde: null,
      hasta: null,
    });
    setIncluyeIntegrantes(false);
    setTodasLasEmpresas(false);
    */
  };

  const accesoDenegado = () => {
    mensajeAlerta(
      "Listados de Afiliados Suspendidos",
      "No tiene permiso para acceder a esta pantalla !.",
      "error",
    );
    exitClick();
    return;
  };

  const renderHeaderFechas = () => {
    return (
      <div>
        <Tag value="Afiliados Suspendidos"></Tag>
      </div>
    );
  };

  const renderFooterFechas = () => {
    return (
      <div>
        <button
          id="expButtonExcel"
          type="button"
          onClick={(e) => {
            exportExcel();
          }}
          style={{ visibility: "hidden" }}
        >
          Export Excel
        </button>
        <button
          id="expButtonPdf"
          type="button"
          onClick={(e) => {
            exportPdf();
          }}
          style={{ visibility: "hidden" }}
        >
          Export Pdf
        </button>

        <Button
          icon="pi pi-file-excel"
          onClick={(e) => {
            aceptarFechas("excel");
          }}
          className="p-button-raised p-button-success"
          data-pr-tooltip="XLS"
          label="Excel"
        />
        <Button
          icon="pi pi-file-pdf"
          onClick={(e) => {
            aceptarFechas("pdf");
            //exportPdf();
          }}
          className="p-button-raised p-button-warning"
          data-pr-tooltip="PDF"
          style={{ marginRight: "1em" }}
          label="PDF"
        />
        <ButtonMui
          onClick={onHideFechas}
          color="secondary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CloseIcon />}
          autoFocus
        >
          Cancelar
        </ButtonMui>
      </div>
    );
  };

  const fechaTemplate = (rowData) => {
    return <Fragment>{formatDate(rowData.fecha)}</Fragment>;
  };

  const anuladoTemplate = (rowData) => {
    return (
      <Fragment>
        <Checkbox checked={rowData.anulado}></Checkbox>
      </Fragment>
    );
  };

  const exportExcel = () => {
    import("xlsx").then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(listadoExcel);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      saveAsExcelFile(excelBuffer, "suspendidosHasta1Cuota");
    });
  };

  const saveAsExcelFile = (buffer, fileName) => {
    import("file-saver").then((FileSaver) => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      return new Promise((resolve) => {
        saveAs(
          data,
          fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION,
        );
        resolve(true);
      });
    });
  };

  const exportPdf = () => {
    import("jspdf").then((jsPDF) => {
      import("jspdf-autotable").then(() => {
        let doc = null
        if (!a2030) {
        doc = new jsPDF.default("l");
        doc.setFontSize(10);
        doc.text(
          `Listado de afiliados Suspendidos - empresa: ${
            todasLasEmpresas ? "TODAS" : empresaElegida.nombre
          } desde ${formatDate(fechaDesde)} hasta ${formatDate(fechaHasta)} `,
          60,
          8,
        );

        doc.autoTable(exportColumnsListado, listadoExcel, {
          styles: {
            fontSize: 6,
          },
          columnStyles: {
            7: {
              halign: "right",
            },
          },
        });
      } else {
        doc = new jsPDF.default("p");
        doc.setFontSize(10);
        doc.text(
          `Listado de afiliados Suspendidos - empresa: "TODAS"  Hasta 1 cuota `,
          60,
          8,
        );

        doc.autoTable(exportColumnsListado2030, listadoExcel, {
          styles: {
            fontSize: 6,
          },
          columnStyles: {
            7: {
              halign: "right",
            },
          },
        });

      }
        //doc.save("SuspendidosAfiliados.pdf");
        window.open(doc.output("bloburl"));
      });
    });
  };

  function formatDate(input) {
    var datePart = input.match(/\d+/g),
      year = datePart[0],
      month = datePart[1],
      day = datePart[2];
    return day + "/" + month + "/" + year;
  }

  function formatDateTime(dateString) {
    var allDate = dateString.replace("T", " ");
    allDate = allDate.replace(".", " ");
    allDate = allDate.split(" ");
    var thisDate = allDate[0].split("-");
    var thisTime = allDate[1].split(":");
    var newDate = [thisDate[2], thisDate[1], thisDate[0]].join("/");
    var newTime = [thisTime[0], thisTime[1]].join(":");
    return newDate + " " + newTime;
  }

  //console.log(listadoExcel);
  //console.log(serviciosFinalizadosExcel);

  return (
    <Fragment>
      <Menu />
      <Toast ref={toast} />
      {statusAcceso === 0 ? <Spinner /> : null}
      {statusAcceso === 400 ? accesoDenegado() : null}
      {statusAcceso === 200 ? (
        <Fragment>
          <Dialog
            header={renderHeaderFechas()}
            visible={visibleFechas}
            closable={false}
            footer={renderFooterFechas()}
            breakpoints={{ "960px": "75vw" }}
            style={{ width: "70vw", paddingBottom: "0" }}
            position="top"
          >
            <Grid container spacing={3} style={{ marginTop: "1vw" }}>
              <Grid item xs={12} md={4}>
                <TextField
                  id="fechaDesde"
                  label="Fecha Desde"
                  type="date"
                  variant="standard"
                  fullWidth
                  value={fechaDesde ? fechaDesde : null}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) => {
                    guardarFechaDesde(e.target.value);
                  }}
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <TextField
                  id="fechaHasta"
                  label="Fecha Hasta"
                  type="date"
                  variant="standard"
                  fullWidth
                  value={fechaHasta ? fechaHasta : null}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) => {
                    guardarFechaHasta(e.target.value);
                  }}
                />
              </Grid>

              <Grid item xs={12} md={4} />

              <Grid
                item
                xs={6}
                md={3}
                style={{ paddingLeft: "1vw", marginTop: "1vw" }}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      style={{ marginLeft: "1vw", marginRight: "1vw" }}
                      inputId="todasLasEmpresas"
                      onChange={(e) => {
                        setTodasLasEmpresas(e.target.checked);
                      }}
                      checked={todasLasEmpresas ? todasLasEmpresas : false}
                    />
                  }
                  label="Todas Las Empresas"
                />
              </Grid>

              {configuracion && configuracion.destinatario === 2 ? (
                <Grid
                  item
                  xs={6}
                  md={3}
                  style={{ paddingLeft: "1vw", marginTop: "1vw" }}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        style={{ marginLeft: "1vw", marginRight: "1vw" }}
                        inputId="a2030"
                        onChange={(e) => {
                          setA2030(e.target.checked);
                        }}
                        checked={a2030 ? a2030 : false}
                      />
                    }
                    label="Hasta 1 cuota"
                  />
                </Grid>
              ) : null}
            </Grid>
          </Dialog>
        </Fragment>
      ) : null}
      <Grid item xs={12} sm={12}></Grid>
    </Fragment>
  );
}

/* class="MuiDataGrid-cell MuiDataGrid-cellLeft" */
